import { activeIntegrationSelector } from "./activeIntegrationSelector";
import { RootState } from "../../store";

export const activeIntegrationIdSelector = (
  state: RootState,
): string | null => {
  return activeIntegrationSelector(state).id;
};
